// extracted by mini-css-extract-plugin
module.exports = {"promo":"Advertising_promo__1Jcr2","mobile":"Advertising_mobile__2038L","desktop":"Advertising_desktop__1AJVI"};